import { takeLatest, put, call, select } from 'redux-saga/effects';
import UserActions, { UserTypes } from '../Redux/UserRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getUsers(api, { query, callback }) {
    try {
        const response = yield call(api.getUserCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        const pagination = data.pagination ? data.pagination : null;

        yield put(UserActions.fetchUsersSuccess(data.users, pagination));

        // This is just an stupid hack for fullcalendar to work with redux
        if (callback){
            callback(data.users);
        }
    } catch (e) {
        yield put(UserActions.fetchUsersFailure(e));
    }
}

export function * getFlatUsers(api, {query}) {
    try {
        const response = yield call(api.getUserCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.fetchFlatUsersSuccess(response.data.data.users));
    } catch (e) {
        yield put(UserActions.fetchFlatUsersFailure(e));
    }
}

export function * createUser(api, {role_id, user, query}) {
    try {
        const response = yield call(api.postUserCollection, role_id, user, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.createUserSuccess(response.data.data.user));
    } catch (e) {
        yield put(UserActions.createUserFailure(e));
    }
}

export function * getUser(api, { user_id, query }) {
    try {
        const response = yield call(api.getUserResource, user_id, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.fetchUserSuccess(response.data.data.user));
    } catch (e) {
        yield put(UserActions.fetchUserFailure(e));
    }
}

export function * updateUser(api, {user_id, user, query}) {
    try {
        const response = yield call(api.patchUserResource, user_id, user, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.updateUserSuccess(response.data.data.user));
    } catch (e) {
        yield put(UserActions.updateUserFailure(e));
    }
}

export function * deleteUser(api, {user_id, query}) {
    try {
        const response = yield call(api.deleteUserResource, user_id );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.deleteUserSuccess());
        yield call(getUsers, api, {query});
    } catch (e) {
        yield put(UserActions.deleteUserFailure(e));
    }
}

export function * getRoles(api, { query }) {
    try {
        const response = yield call(api.getRoleCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.fetchRolesSuccess(response.data.data.roles));
    } catch (e) {
        yield put(UserActions.fetchRolesFailure(e));
    }
}

export function * getProfile(api, { query }) {
    try {
        const response = yield call(api.getProfileCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UserActions.fetchProfileSuccess(response.data.data.profile));
    } catch (e) {
        yield put(UserActions.fetchProfileFailure(e));
    }
}

export function * updateProfile(api, {user, query}) {
    try {
        const response = yield call(api.putProfileCollection, user, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const profile = response.data.data.profile;
        const userCurrentAvatar = JSON.parse(localStorage.getItem('user_avatar'));
        const newAvatar = (profile.avatar !== null) ? profile.avatar.url : userCurrentAvatar;
        localStorage.setItem('user_avatar', JSON.stringify(newAvatar));
        yield put(UserActions.updateProfileSuccess(profile));
    } catch (e) {
        yield put(UserActions.updateProfileFailure(e));
    }
}

export function * watchUsers(api) {
    yield takeLatest(UserTypes.FETCH_USERS, getUsers, api);
    yield takeLatest(UserTypes.FETCH_FLAT_USERS, getFlatUsers, api);
    yield takeLatest(UserTypes.CREATE_USER, createUser, api);
    yield takeLatest(UserTypes.FETCH_USER, getUser, api);
    yield takeLatest(UserTypes.UPDATE_USER, updateUser, api);
    yield takeLatest(UserTypes.DELETE_USER, deleteUser, api);
    yield takeLatest(UserTypes.FETCH_ROLES, getRoles, api);

    yield takeLatest(UserTypes.FETCH_PROFILE, getProfile, api);
    yield takeLatest(UserTypes.UPDATE_PROFILE, updateProfile, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/UserSagas.js